<script setup lang="ts">
import type { TextSize } from '.';

const { size = 'md', as = 'span' } = defineProps<{
  size?: TextSize;
  as?: string;
}>();
defineSlots<{ default: () => void }>();
</script>

<template>
  <component
    :is="as"
    :class="{
      'text-sm md:text-base': size === 'sm',
      'text-base lg:text-lg': size === 'md',
      'text-xl': size === 'lg',
      'text-2xl xl:text-xl 2xl:text-2xl': size === 'xl',
      'text-xl lg:text-2xl 2xl:text-[2.5rem]': size === '2xl',
      'text-2xl lg:text-5xl': size === '3xl',
      'text-5xl lg:text-[4rem]': size === '4xl',
    }"
  >
    <slot />
  </component>
</template>
